<div class="page-header container d-lg-none" [ngClass]="{ 'hide-footer': !showFooter }">
  <div class="d-flex align-items-center text-white">
    <div class="banner-name">
      <a (click)="goBack()" class="btn back-btn text-white px-0 z-2">
        <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
      </a>
      <h4 class="page-title mb-0" [ngClass]="{ 'text-title-center': !showBalance }">
        {{ pageTitle | translate | uppercase }}
      </h4>
    </div>
    <div class="ms-auto d-flex align-items-center font-size-14 widget-details" *ngIf="showBalance">
      <button class="qrcode-btn text-white gloss-black" (click)="goToWallet()">
        <span class="icon material-icons material-mobile-nav">qr_code_2</span>
      </button>
    </div>
    <div class="footer"></div>
  </div>
  <ng-container *ngTemplateOutlet="template"></ng-container>
  @if(showQr){
  <fgb-barcode [displayQrCode]="true" [showDiscounts]="true" />
  }
  <div class="footer"></div>
</div>
